import {Injectable} from '@angular/core';
import {ConfigurationService} from './configuration.service';
import {ConfigurationModel} from '../models/configuration.model';
import {HttpClient, HttpEventType} from '@angular/common/http';
import {UrlEndpoints} from '../definitions/url-endpoints';
import {GeneralService} from './general.service';
import {catchError, delay, timeout} from 'rxjs/operators';
import {StateManagerService} from './state-manager.service';
import {CollectionsNames} from '../definitions/collections-names';
import {of} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DefineHostAddressService {
    config: ConfigurationModel;

    constructor(private configService: ConfigurationService,
                private stateManager: StateManagerService,
                private http: HttpClient,
                private urlEndpoints: UrlEndpoints,
                private generalServices: GeneralService,
                private collectionNames: CollectionsNames) {
    }

    async defineHostAdd() {
        this.config = this.stateManager.getCollection(this.collectionNames.CONFIGURATION);
        console.log(this.config);
        return new Promise((resolve, reject) => {
            this.pingAdd(this.config.primaryAddress).then(() => {
                this.config.host = this.config.primaryAddress;
                this.stateManager.update('configuration', this.config);
                resolve(true);
            }).catch(() => {
                this.pingAdd(this.config.secondaryAddress).then(() => {
                    console.log('Trying Secondary Address');
                    this.config.host = this.config.secondaryAddress;
                    this.stateManager.update('configuration', this.config);
                    resolve(true);
                }).catch(() => {
                    this.config.host = this.config.primaryAddress;
                    this.stateManager.update('configuration', this.config);
                    if (!this.config.offLineMode) {
                        this.generalServices.createToast('No connection to the server');
                    }
                    reject(false);
                });
            });
        });
    }

    pingAdd(add) {
        return new Promise((resolve, reject) => {
            try {
                this.http.get(this.configService.getProtoCol() + add + ':' + this.config.port +
                    this.configService.getService() + this.urlEndpoints.testConnectionEndpoint, {
                    reportProgress: true,
                    observe: 'events'
                }).pipe(timeout(2000)).subscribe(event => {
                    if (event.type === HttpEventType.UploadProgress) {
                    } else if (event.type === HttpEventType.Response) {
                        if (event.status === 200) {
                            resolve(true);
                        }
                        console.log(event);
                    }
                }, error => {
                    reject(false);
                });
            } catch (e) {
                reject(false);
            }
        });
    }

    async defineHostAddAuth() {
        this.config = this.stateManager.getCollection(this.collectionNames.CONFIGURATION);
        console.log(this.config);
        return new Promise((resolve, reject) => {
            this.authAdd(this.config.host).then(() => {
                this.stateManager.update('configuration', this.config);
                resolve(true);
            }).catch(() => {
                this.authAdd(this.config.primaryAddress).then(() => {
                    console.log('Trying Secondary Address');
                    this.config.host = this.config.primaryAddress;
                    this.stateManager.update('configuration', this.config);
                    resolve(true);
                }).catch(() => {
                    this.authAdd(this.config.secondaryAddress).then(() => {
                        console.log('Trying Secondary Address');
                        this.config.host = this.config.secondaryAddress;
                        this.stateManager.update('configuration', this.config);
                        resolve(true);
                    }).catch(() => {
                        if (!this.config.offLineMode) {
                            this.generalServices.createToast('No connection to the server');
                        }
                        reject(false);
                    });
                });
            });
        });
    }

    authAdd(add) {
        const apiKey = {'apikey': this.config.apikey};
        return new Promise((resolve, reject) => {
            try {
                this.http.post(this.configService.getProtoCol() + add + ':' + this.config.port +
                    this.configService.getService() + this.urlEndpoints.authenticationPostEndPoint,
                    apiKey, {responseType: 'text'}).toPromise().then(() => {
                    resolve(true);
                }).catch(err => {
                    reject(err);
                });
            } catch (e) {
                reject(false);
            }
        });
    }
}
